<template>
    <div class="vx-card p-6">
        <ag-grid-vue style="height: 55vh"
                     ref="agGridTable"
                     :components="components"
                     :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="activeData"
                     :animateRows="true"
                     :pagination="true"
                     :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                     :paginationPageSize="paginationPageSize"
                     :onGridReady="onGridReady"
                     :suppressPaginationPanel="true">
        </ag-grid-vue>
    </div>
</template>
<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

export default {
    components:{
        AgGridVue
    },
    data(){
        return {
            activeData:[
                { stt:'đang hoạt động',
                  time:'10h50',
                  from:'Ninh Bình city',
                  to:'Hà Nội'
                },
                { stt:'không hoạt động',
                  time:'10h50',
                  from:'Ninh Bình city',
                  to:'Hà Nội'
                },
            ],
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'Trạng thái',
                    field: 'stt',
                    width: 300
                },
                {
                    headerName: 'Thời gian',
                    field: 'time',
                    width: 300,
                },
                {
                    headerName: 'Từ',
                    field: 'from',
                    width: 300
                },
                {
                    headerName: 'Đến',
                    field: 'to',
                    width: 300
                },
            ],
        }
    }
}
</script>